import { LOGGED_IN, LOGGED_OUT } from "./constants";

export function authRuleFactory(isAuthenticated) {
  return async function authRule(node) {
    const { authState } = node;

    if (!authState) return true;

    return (
      (authState === LOGGED_IN && isAuthenticated) ||
      (authState === LOGGED_OUT && !isAuthenticated)
    );
  };
}
